mobileSize = 1000;
function buttonfeature() {
  const e = $(".featureLineupContainer");
  e.length > 0 &&
      e.each((index, element) => {
          const i = $(element).find(".featureLineup-more"),
              n = $(element).find(".featureLineup-text");
              t =$(element).find(".featureLineup-title")
          if (n.length > 0) {
              const a = n.text();
              n.html(`<span class="featureLineup-text-content">${a}</span>`), i.appendTo(n), t.clone().appendTo(n);
          } else {
              $(element).append('<div class="button-wrap"></div>'); // Add your content for the new div here
              i.appendTo($(element).find('.button-wrap'));
              t.clone().appendTo(n)
          }
      });
}

$(document).ready(function(){
  let prevPage = (document.referrer).split('/');
  if (prevPage[4] == 'hooplandia' && window.location.pathname == "/search.aspx") {
    $('body').addClass('fair-home')
  }
  buttonfeature();
 // HOOPLANDIA HOMEPAGE STRUCTURE
 if ($('body').hasClass('fair-home')) {

  $('.content').append(`  
      <div class="fair-container">
      <div class="tier-one"></div>
      <div class="tier-two">
      </div>
      <div class="tier-three">  
      <div class="tier-three-container">
      <div class ="sign-container">
      <div class="sign-innerouter">
      <h1>Join the Party!</h1>
      </div>  
      </div>
      </div>
      <div class="tier-four"></div>
      <div class="tier-five"></div>
      </div>
      `)
      
} else {
  $('.content').append(`
      <div class="fair-container">
    
      </div>
          `)
  $('#fairmanagedLogo').remove();
  $('.ticket.fair-ticket').remove()
  $('#FairmainFeatureSlide ').remove();
   $('.afterContent .emailSignup.modalOnly').remove();
$('#fairseo').remove();
$('#faircards').remove();
$('#fairSocialNetworkWidget').remove();
$('#fairSponsors').remove();
$('#footerinfo').remove();
$('#faircardWidgetMap').remove();
 $('.fair-container').remove();
 $('#siteInfoBannerWidget').remove();
 
}

if ($('body').hasClass('fairSubpage')) {
  $('.fair-container ').remove();

}

$('#FairmainFeatureSlide').appendTo('.fair-home .tier-one, .fairSubpage .tier-one')

  //HEADER-----------
  const hooplandiaHeaderMenu = `
  <div class="fair-top-container">
  <div class="inner-container"> 
  <div class="hop-logo"></div>
  <div class="hop-toggle"></div>
  <div class="hop-countdown"></div>
  <div class ="container-items">
  <div class="hop-search"></div>
  <div class="hop-cart"></div>
  <div class="hop-ticket"></div>
  </div>
  </div>  
  </div>
  `

$('#fair-container').append(hooplandiaHeaderMenu)

$('.header .searchBox').appendTo('.fair-home #fair-container .hop-search')
$('.header .viewcart').appendTo('.fair-home #fair-container .hop-cart')
$('.header .fair-ticket').appendTo('.fair-home #fair-container .hop-ticket')
$('.header .mobile-nav-toggle').appendTo('.fair-home #fair-container .hop-toggle')
$('#siteInfoBannerWidget').appendTo('.fair-home #fair-container .hop-countdown')
$('.emailSignup.modalOnly').appendTo('.fair-home .sign-innerouter')
// $('.mobile-nav-toggle').clone().appendTo('.fair-home .sign-innerouter')
$('.footeritem').appendTo('.fair-home .footeritem')
$('#splash').appendTo('#splashPage')
//footer
const hooplandiaFooter = `
<div class="footer-center">
<div class="footer-fair-logo"></div>
<div class="footer-fairinfo"></div>
<div class="footeritem"></div>
</div>`

$('.fair-footer').append(hooplandiaFooter)
$('#footerinfo').appendTo('.fair-footer .footer-fairinfo')
  $('.header-logo').clone().appendTo('.mobile-menu-header');
  $('#hlnk_mobileTicketBtn').wrapAll('<div class="container-itemss"></div>');
   // Search Bar Script
   $('.searchBoxInput input').attr('placeholder', 'Search Website');
   $('.searchBoxInput input').val('');
   $('.mobile-menu-container .search-container').attr('placeholder', 'Search Website');
   $('#mobileSearchInput').val('');
 
   // ========================
   // Signup script
   // text
   $('.signup-container .emailSignup .emailSignupText').text('Recieve a treasure trove of exclusive pre-sales, discounts, and contests, not to mention, you’ll never miss a fairgrounds event.')
 
   // button
   $('.signup-container .emailSignup .emailInputSubmit a').text('SUBSCRIBE')
 //text fair

   $('.tier-three-container .sign-innerouter .emailSignup .emailSignupText').text('Sign up for news on deals and events for Ozark Empire Fair!')
   $('.tier-three-container .sign-innerouter .emailSignup .emailInputSubmit a').text('SUBSCRIBE')
   // button
   $('.signup-container .emailSignup .emailInputSubmit a').text('SUBSCRIBE')
   // input
   $('.signup-container .emailSignup .emailInputField input').attr('placeholder', 'email address');
   $('.signup-container .emailSignup .emailInputField input').val('');
   // input
   $('.tier-three-container .sign-innerouter .emailSignup .emailInputField input').attr('placeholder', 'email address');
   $('.tier-three-container .sign-innerouter .emailSignup .emailInputField input').val('');
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 1000) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 1001) {
    $('body').removeClass('saffireMobileSize');
  }
  
  // General Message
  $('.generalmessage').prependTo('header');

  // Replace Saffire Logo
	$('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire.png`);
});


$(window).load(function(){
	$('body').addClass('pageIsLoaded');
});
